import { render } from "./cryptocurrency.vue?vue&type=template&id=6fc0e236"
import script from "./cryptocurrency.vue?vue&type=script&lang=js"
export * from "./cryptocurrency.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__